export default __webpack_public_path__ + "static/media/social-studies.42e4b2ca.png";